import { Component, OnInit, AfterViewInit, inject } from "@angular/core";
import { PrintDocument } from "../print-document";
import { Title } from "@angular/platform-browser";
import { IReservationReport } from "../../utils/interfaces/reservation-report";
import { IReportFilter } from "../../utils/interfaces/report-filter";
import { CommonModule } from "@angular/common";
import { PrintFilterDataComponent } from "../../shared/components/print-filter-data/print-filter-data.component";
import { ReservationCardComponent } from "../../main/report/report-data/reservation/reservation-card/reservation-card.component";

@Component({
    selector: 'app-print-reservation',
    standalone: true,
    imports: [CommonModule, PrintFilterDataComponent, ReservationCardComponent],
    templateUrl: '../../main/report/report-data/reservation/reservation.component.html',
    styleUrls: ['../../main/report/report-data/reservation/reservation.component.scss'],
})
export class PrintReservationComponent extends PrintDocument implements OnInit, AfterViewInit {


    print = true;
    private readonly titleService = inject(Title);
    data: IReservationReport[] = [];
    filter!: IReportFilter;
    title = '';

    ngOnInit(): void {
        this.handleData();
    }

    ngAfterViewInit(): void {
        this.reportReadyData();
    }

    protected override handleData(): void {
        const { data, filter } = this.activatedRoute.snapshot.data['data'];

        this.data = data || [];
        this.filter = filter;
        this.title = this.data.length > 0 ? this.data[0].title : '';

        this.titleService.setTitle(
            this.changeTitlePage(
                'Relatório de reserva de pratos',
                this.filter.startDate,
                this.filter.finishDate
            )
        );
    }

    protected override reportReadyData(): void {
        setTimeout(() => {
            this.printDocumentService.onDataReady();
        }, 3000);
    }

    exportToExcel() {}
}